import { UserAccess } from "../../../../common/utils/PermissionsUtils";


interface Divize {
    id: number;
    nazev: string;
}

interface Klub {
    id: number;
    nazev: string;
    nazevDivize: string;
    cisDivize: number;
    cisKlubu: number;
    datVstupu: Date;
}


interface Adresa {
    ulice: string;
    obec: string;
    psc: string;
    posta: string;
}

interface OsobniUdaje {
    id: number;
    idtClena: number;
    prijmeni: string;
    jmeno: string;
    titul: string;
    datNaroz?: Date;
    bydliste?: Adresa;
    telefon?: string;
    email?: string;
    vekKtg: string;
    vekKtg2: string;
    divize?: Divize;
    klub?: Klub;
    senior: boolean;
    verified: boolean;
    userAccess: UserAccess;
    showMemberCardLink: boolean;
}


export {
    UserAccess,
    OsobniUdaje,
}